<template>
    <v-container>
        <v-card>
            <v-card-title>
                <h4>Выбор лесного участка</h4>
            </v-card-title>
            <v-card-text>
                <v-form class="px3">
                    <v-select
                        :items="input.regions"
                        v-model="region_id"
                        label="Субъект РФ"
                        required
                    ></v-select>
                    <v-select :disabled="region_id == 0"
                        :items="input.forestries"
                        v-model="forestry_id"
                        label="Лесничество"
                        required
                    ></v-select>
                    <v-select :disabled="forestry_id == 0"
                        :items="input.localforestries"
                        v-model="localforestry_id"
                        label="Участковое лесничество"
                        required
                    ></v-select>
                    <v-select :disabled="subforestry_id == -1 || localforestry_id == 0"
                        :items="input.subforestries"
                        v-model="subforestry_id"
                        label="Урочище"
                        required
                    ></v-select>
                    <v-combobox
                        v-model="kv"
                        :items="input.kvs"
                        chips
                        multiple
                        label="Список кварталов"
                        :disabled="subforestry_id == 0"
                    ></v-combobox>
                </v-form>
            </v-card-text>
        </v-card>
    </v-container>
</template>
<script>
export default {
  name: 'addresComponent',
  components: {
  },
  data () {
    return {
        input: {
            regions: [],
            forestries: [],
            localforestries: [],
            subforestries: [],
            kvs: []
        }
    }
  },
  mounted: function() {
    this.UpdateFilter().then(function(res) {
      this.region_id = 24
    })
  },
  watch: {
    filterArray(newE, oldE) {
        this.UpdateFilter()
    }
  },
  methods: {
    UpdateFilter () {
        return this.$http.get('php_scripts/glpm/regionFilterGlpm.php', {params: this.$store.state.glpm.filter}).then((res) => {
          if(res.data.subforestries[0].value == -1 && this.subforestry_id == 0) {
            this.subforestry_id = -1
            this.UpdateFilter()
          } else {
            this.input.regions = res.data.regions
            this.input.forestries = res.data.forestries
            this.input.localforestries = res.data.localforestries
            this.input.subforestries = res.data.subforestries
            this.input.kvs = res.data.kvs
          }
        }).catch((err) => {
          console.log(err)
        })
    },
  },
  computed: {
    filterArray() {
        return [this.region_id,this.forestry_id,this.localforestry_id, this.subforestry_id,this.kv]
    },
    region_id: {
      get () {
        return this.$store.state.glpm.filter.region_id
      },
      set (value) {
        this.$store.commit('setGlpmFilter', {type: 'region_id', items: value})
        this.$store.commit('setGlpmFilter', {type: 'forestry_id', items: 0})
        this.$store.commit('setGlpmFilter', {type: 'localforestry_id', items: 0})
        this.$store.commit('setGlpmFilter', {type: 'subforestry_id', items: 0})
        this.$store.commit('setGlpmFilter', {type: 'kv', items: []})
      }
    },
    forestry_id: {
      get () {
        return this.$store.state.glpm.filter.forestry_id
      },
      set (value) {
        this.$store.commit('setGlpmFilter', {type: 'forestry_id', items: value})
        this.$store.commit('setGlpmFilter', {type: 'localforestry_id', items: 0})
        this.$store.commit('setGlpmFilter', {type: 'subforestry_id', items: 0})
        this.$store.commit('setGlpmFilter', {type: 'kv', items: []})
      }
    },
    localforestry_id: {
      get () {
        return this.$store.state.glpm.filter.localforestry_id
      },
      set (value) {
        this.$store.commit('setGlpmFilter', {type: 'localforestry_id', items: value})
        this.$store.commit('setGlpmFilter', {type: 'subforestry_id', items: 0})
        this.$store.commit('setGlpmFilter', {type: 'kv', items: []})
      }
    },
    subforestry_id: {
      get () {
        return this.$store.state.glpm.filter.subforestry_id
      },
      set (value) {
        this.$store.commit('setGlpmFilter', {type: 'subforestry_id', items: value})
        this.$store.commit('setGlpmFilter', {type: 'kv', items: []})
      }
    },
    kv: {
      get () {
        return this.$store.state.glpm.filter.kv
      },
      set (value) {
        var vals = value.map(function(name) {
          if (typeof(name) === 'object') {
            return name.value
          }
          else {
            return name
          }
        })
        this.$store.commit('setGlpmFilter', {type: 'kv', items: vals})
      }
    }
  }
}
</script>